export default {
  getAllCategory(state, payload) {
    state.categoryList = payload;
  },

  getOneCategory(state, payload) {
    state.oneCategory = payload;
  },
};
